import axios from '@/plugins/axios'

/**
 * ask questions - IA
 */
const askQuestions = async ({ message }) => {
  try {
    const params = {
      message: message
    }
    const response = await axios.post(process.env.VUE_APP_IA_AGENT_BASE_URL + '/chat', params)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  askQuestions
}
